import { PulseLoader } from "react-spinners";

export function Loader() {
  return (
    <div className="flex justify-center items-center">
      <PulseLoader color="lightgray" loading={true} size={15} speedMultiplier={0.6} />
    </div>
  );
}
